import { styled } from '@uhg-abyss/web/tools/styled';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Toggle } from '@uhg-abyss/web/ui/Toggle';

import { Markdown } from '../../../common/Markdown';

export const StyledDrawer = styled(Drawer, {
  zIndex: '1080 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
  },
  '.abyss-modal-base-content-container': {
    borderRadius: 0,
    '@media (max-width: 984px)': {
      '& .abyss-modal-base-body > div': {
        marginLeft: '0px',
        marginRight: '0px',
      },
    },
    '@media (max-width: 464px)': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
      '& .abyss-modal-base-body > div': {
        marginLeft: '16px',
        marginRight: '16px',
      },
    },
  },
  '.abyss-modal-close-button': {
    zIndex: '9999 !important',
    '@media (max-width: 464px)': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-base-body': {
    scrollbarWidth: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
    '::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'auto !important',
  },
});

const headingStyle = {
  fontFamily: '$core.color.neutral.100 !important',
  fontWeight: '700 !important',
  fontSize: '23px !important',
  lineHeight: '24px !important',
  letterSpacing: '0px',
};

export const HeadingText = styled(Heading, {
  ...headingStyle,
});

export const HeadingTextOnBoarding = styled('span', {
  fontFamily: '$core.color.neutral.100',
  fontWeight: '700 ',
  fontSize: '18px',
  lineHeight: '24px',
  letterSpacing: '0px',
  color: '$core.color.neutral.90',
});

export const DescriptionTextOnboarding = styled(Text, {
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '22px',
  color: '$core.color.neutral.80',
  marginTop: '2px',
});

export const OnboardingDisclaimerText = styled('span', {
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '18px',
  color: '#323333',
  letterSpacing: '0px',
  display: 'block',
});

export const FlexContainer = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  marginTop: '16px',
  marginBottom: '16px',
  gap: '12px',
});

export const ListItemIconContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  height: '24px',
});

export const ListItemContentContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const ToggleSwitchField = styled(Toggle, {
  padding: '4px 16px 4px 16px',
  '& .abyss-toggle-label': { marginLeft: '8px' },
});

export const AccordionContainer = styled(Accordion, {
  paddingLeft: '16px',
  paddingRight: '16px',
  fontFamily: '$core.color.neutral.100',
  backgroundColor: 'transparent',
  '& .abyss-accordion-trigger': {
    color: '$core.color.neutral.90',
    padding: '0px',
    cursor: 'pointer',
    border: 'none',
    '&:hover': { backgroundColor: '#FAFAFA' },
    '& .abyss-accordion-header': {
      fontWeight: '500',
      fontSize: '18px',
    },
    '& .abyss-accordion-header-subtext': {
      fontSize: '16px',
      fontWeight: '400',
      color: '$core.color.neutral.90',
    },
    '& .abyss-heading-root': {
      fontSize: '18px',
      fontWeight: '500',
    },
  },
  '& .abyss-radio-group-container': { marginTop: '16px' },
  '& .abyss-checkbox-group-container': {
    marginTop: '16px',
    maxHeight: '300px',
    overflow: 'auto',
  },
  '& .abyss-checkbox-flex-container': {
    margin: '4px',
  },
  '& .abyss-accordion-content-text': { padding: '0px 0px 10px 4px' },
});

export const StyledMarkdown = styled(Markdown, {
  fontSize: '18px',
  fontWeight: '400',
  lineHeight: '24px',
  color: '$core.color.neutral.90',
  'abyss-layout-stack': {
    paddingTop: '8px',
  },
  '.abyss-icon-symbol': {
    fontSize: '18px !important',
    paddingTop: '2px',
    color: '$core.color.brand.60 !important',
  },
  '.abyss-link-root': {
    fontSize: '14px',
    lineHeight: '18px',
    borderColor: 'white !important',
  },
  '.abyss-flex-root': {
    paddingLeft: '5px',
  },
  '.abyss-accordion-trigger': {
    border: 'none',
    padding: '0px',
  },
});

export const ClearAllButton = styled(Button, {
  background: 'transparent !important',
  border: 'none !important',
  padding: '0',
  cursor: 'pointer',
  outline: 'none',
  boxShadow: 'none',
  '&:hover': {
    background: 'transparent !important',
    border: 'none ',
    boxShadow: 'none',
  },
});

export const StyledDivider = styled(Divider, {
  '&.abyss-divider-root': {
    border: '0.5px solid #CCCCCC',
    marginTop: '$md !important',
    marginBottom: '$md !important',
  },
});

export const InfoStyledDrawer = styled(Drawer, {
  '.abyss-modal-header-container': {
    borderBottom: '2px solid #E5E5E6 !important',
  },
});

export const NewStyledDrawer = styled(Drawer, {
  zIndex: '1080 !important',
  '.abyss-modal-header-container': {
    borderBottom: '2px solid #E5E5E6 !important',
  },
  '.abyss-modal-content-title': {
    paddingTop: '0px !important',
  },
  '.abyss-modal-base-content-container': {
    borderRadius: 0,
    '@media (max-width: 984px)': {
      '& .abyss-modal-base-body > div': {
        marginLeft: '0px',
        marginRight: '0px',
      },
    },
    '@media (max-width: 464px)': {
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
      '& .abyss-modal-base-body > div': {
        marginLeft: '16px',
        marginRight: '16px',
      },
    },
  },
  '.abyss-modal-close-button': {
    zIndex: '9999 !important',
    top: '12px',
    right: '12px',
  },
  '.abyss-modal-base-body': {
    scrollbarWidth: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
    '::-webkit-scrollbar': {
      display: 'none',
      overflow: 'auto !important',
    },
  },
  '.abyss-modal-footer': {
    zIndex: '1080 !important',
    padding: '16px',
    borderTop: '2px solid #E5E5E6 !important',
  },
});

export const SearchInputWrapper = styled('div', {
  padding: '7px 14px 10px 14px',
  borderBottom: '1px solid #D1D3D4',
});
